import { render } from "./ProfileLinks.vue?vue&type=template&id=1828b600"
import script from "./ProfileLinks.vue?vue&type=script&lang=js"
export * from "./ProfileLinks.vue?vue&type=script&lang=js"

import "./ProfileLinks.vue?vue&type=style&index=0&id=1828b600&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__